// extracted by mini-css-extract-plugin
export default {"wrapper":"date-range-picker-modal_wrapper__OKVpp","buttons":"date-range-picker-modal_buttons__YUlQp","opacity-transition":"date-range-picker-modal_opacity-transition__WUlEd"};